var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompensation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#D8ECFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3535 27.2109L38.2736 19.2422L54.355 35.4224",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3535 27.2109L38.2736 19.2422L54.355 35.4224",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3535 27.3213L33.2934 25.9307L35.9041 27.4758L38.5369 25.9307L41.1476 27.4758L43.7584 25.9307L46.3692 27.4758",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8716 36.6147L51.1957 45.9962H32.5693L41.8716 36.6147Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3105 13.0837C42.0692 11.4944 40.687 10.2582 39.0415 10.2582C38.8002 10.2582 38.5589 10.2803 38.3395 10.3465C37.5936 9.52978 36.5405 9 35.3338 9C33.4251 9 31.8235 10.3244 31.3848 12.1124C30.5949 12.1124 29.8929 12.4877 29.4541 13.0837H42.3105Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4199 13.0837H42.5735V13.0396C42.5077 13.0616 42.4638 13.0616 42.4199 13.0837Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5775 25.5332L35.0701 39.1087L39.8967 34.2524L52.2047 46.6359H10.2568",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3179 49.7046H13.2627",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2698 49.7046H21.1826",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1943 53.0815H14.3379",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5031 53.0815H29.3877",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13867 49.7046H11.53",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6256 43.4089C19.2849 43.4089 22.2513 40.4242 22.2513 36.7425C22.2513 33.0608 19.2849 30.0762 15.6256 30.0762C11.9664 30.0762 9 33.0608 9 36.7425C9 40.4242 11.9664 43.4089 15.6256 43.4089Z",
    fill: "#C5E1F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1719 34.1201V47.4749",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1719 40.985L18.0459 38.0933",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1719 39.5504L12.2979 36.6587",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4669 38.1378C28.4669 40.7866 26.3388 42.9278 23.7061 42.9278C21.0734 42.9278 18.9453 40.7866 18.9453 38.1378V19.5073C18.9453 16.8585 21.0734 14.7173 23.7061 14.7173C26.3388 14.7173 28.4669 16.8585 28.4669 19.5073V38.1378Z",
    fill: "#9AC7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7275 16.5933V47.4747",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7275 39.5504L26.6016 36.6587",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7276 39.5504L20.8535 36.6587",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7275 34.0318L26.6016 31.1401",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7276 34.0318L20.8535 31.1401",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7275 28.5132L26.6016 25.6436",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7276 28.5132L20.8535 25.6436",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7275 23.0172L26.6016 20.1255",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7276 23.0172L20.8535 20.1255",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3433 19.7943C50.4395 19.7943 52.1388 18.0846 52.1388 15.9755C52.1388 13.8665 50.4395 12.1567 48.3433 12.1567C46.2472 12.1567 44.5479 13.8665 44.5479 15.9755C44.5479 18.0846 46.2472 19.7943 48.3433 19.7943Z",
    fill: "#9AC7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 45,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompensation);
export default __webpack_public_path__ + "static/media/compensation.21147479fce4134e236f995a7130cfe3.svg";
export { ForwardRef as ReactComponent };